import MainLayout from '@/pages/Layout/MainLayout.vue'
const PostLetters = () => import('@/pages/post/Letters.vue')
const PostRegisters = () => import('@/pages/post/Registers.vue')

export default {
  path: '/post',
  redirect: '/post/letters',
  component: MainLayout,
  children: [
    {
      path: 'letters',
      component: PostLetters,
      meta: {
        title: 'Почтовые отправления',  
      }
    },
    {
      path: 'registers',
      component: PostRegisters,
      meta: {
        title: 'Почтовые реестры',  
      }
    }
  ]
}